module.exports = __webpack_public_path__ + "img/1_HIGH_TEMPERATURE_APPLICATION.4530d090.jpg";